import React from "react";
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarMenu,
  SidebarLink,
  SidebarRoute,
  SideBtnWrap,
} from "./SidebarElements";

const Sidebar = ({ isOpen, toggle }) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarMenu>
        <SidebarLink to="/">Anasayfa</SidebarLink>
        {/* <SidebarLink to="/menu">Menü</SidebarLink> */}
        {/* <SidebarLink to="/hakkimizda">Hakkımızda</SidebarLink> */}
        <SidebarLink to="/iletisim">İletişim</SidebarLink>
      </SidebarMenu>
      <SideBtnWrap>
        <SidebarRoute
          onClick={() => {
            window.location =
              "https://forms.gle/YKJ68zNuDkrogV3K6";
          }}
        >
          Başvuru Yap
        </SidebarRoute>
      </SideBtnWrap>
    </SidebarContainer>
  );
};

export default Sidebar;
